import { useState } from "react"
import { Button, Textarea } from "../../ui"

const NO_CONFLICT = "none"
const HAS_CONFLICT = "declare"

const CONFLICT_EXAMPLES = [
  "Financial interest or personal benefit involving the supplier",
  "Family or close personal relationship with the supplier",
  "Current or previous employment with the supplier",
  "Paid or unpaid work for the supplier or a competing supplier",
  "Gifts, hospitality, commissions, referral fees, or other benefits",
  "Any other relationship or circumstance that could affect, or appear to affect, your judgment",
]

export default function ConflictOfInterestModal({ vendorName, initialNote = "", onCancel, onConfirm }) {
  const [answer, setAnswer] = useState(null)
  const [note, setNote] = useState(initialNote)
  const canConfirm = answer === NO_CONFLICT || (answer === HAS_CONFLICT && !!note.trim())

  return (
    <div
      className="pc-modal-overlay"
      role="dialog"
      aria-modal="true"
      style={{ zIndex: 1400 }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel()
      }}
    >
      <div className="pc-modal" style={{ maxWidth: 600 }}>
        <div className="pc-modal-head">
          <div className="pc-modal-title">Conflict of Interest Declaration</div>
        </div>
        <div className="pc-modal-body" style={{ fontSize: 14, lineHeight: 1.5 }}>
          <p style={{ marginTop: 0 }}>
            Before proceeding, please confirm that you have considered whether you have any actual, potential, or
            perceived conflict of interest related to this supplier{vendorName ? ` (${vendorName})` : ""} or request.
          </p>
          <p style={{ marginBottom: 4 }}>A conflict of interest may include:</p>
          <ul style={{ marginTop: 0, paddingLeft: 20 }}>
            {CONFLICT_EXAMPLES.map((text) => (
              <li key={text}>{text}</li>
            ))}
          </ul>
          <p>
            <b>Please note:</b> Having a conflict of interest does not necessarily mean you cannot proceed with the
            request. However, you must declare it and, where applicable, refrain from participating in the
            decision-making or approval process.
          </p>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Confirmation</div>
          <label style={{ display: "flex", gap: 8, alignItems: "flex-start", cursor: "pointer", marginBottom: 6 }}>
            <input
              type="radio"
              name="coi-answer"
              checked={answer === NO_CONFLICT}
              onChange={() => setAnswer(NO_CONFLICT)}
            />
            I confirm that I have considered the above and have no conflict of interest to declare.
          </label>
          <label style={{ display: "flex", gap: 8, alignItems: "flex-start", cursor: "pointer" }}>
            <input
              type="radio"
              name="coi-answer"
              checked={answer === HAS_CONFLICT}
              onChange={() => setAnswer(HAS_CONFLICT)}
            />
            I have a conflict of interest or potential conflict of interest and will declare it before proceeding.
          </label>
          {answer === HAS_CONFLICT && (
            <div style={{ marginTop: 12 }}>
              <Textarea
                label="Conflict of interest declaration"
                required
                placeholder="Describe the conflict of interest and how it is being managed"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                rows={3}
              />
            </div>
          )}
        </div>
        <div className="pc-modal-foot">
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => onConfirm(answer === HAS_CONFLICT ? note : null)} disabled={!canConfirm}>
            Confirm &amp; Continue
          </Button>
        </div>
      </div>
    </div>
  )
}
